<template>
  <section>
    <vs-popup
      title="Nova Venda"
      :active.sync="saleNew"
    >
      <vs-row>
        <vs-card style="text-align: center;">
          <vs-col :key="indextr" v-for="(tr, indextr) in infoSale">
            <div>
              <div>
                <vs-avatar
                  v-if="tr.IMAGEMVENDEDOR"
                  style="border: 3.5px solid;"
                  size="150px"
                  :src="`data:image/png;base64,${tr.IMAGEMVENDEDOR}`"
                />
                <vs-avatar
                  v-else
                  style="border: 3.5px solid;"
                  size="150px"
                />
              </div>
              <div style="margin-top: 10px;">
                <h1>{{ tr.VENDEDOR }}</h1>
              </div>
              <div style="margin-top: 5px;">
                <span style="font-size: 15px;">{{ tr.COORDENADOR }}</span>
              </div>
              <vs-divider/>
              <div style="display: flex; justify-content: center; margin-top: 5px;">
                <span style="font-size: 20px; margin-top: -1.15px;" class="material-icons">
                  place
                </span>
                <span style="font-size: 16.5px;">
                  {{ tr.FILIAL }}
                </span>
              </div>
              <div style="display: flex; justify-content: center; margin-top: 5px;">
                <span style="font-size: 20px; margin-top: -0.5px; margin-right: 5px;" class="material-icons">
                  school
                </span>
                <span style="font-size: 16.5px;">
                  {{ tr.CURSO }}
                </span>
              </div>
            </div>
          </vs-col>
        </vs-card>
      </vs-row>
    </vs-popup>
  </section>
</template>

<script>
/*import NewSale from "../../services/commission";
import ImageSale from "../../services/imageSale";
import JSConfetti from 'js-confetti';*/
export default {
  data(){
    return{
      saleNew: false,
      sl: [],
      infoSale: [],
    }
  },
  /*mounted(){
    this.buscarEMostrarNovasVendas();

    setInterval(() => {
      this.buscarEMostrarNovasVendas();
    }, 5 * 60 * 1000);
  },
  methods: {
    buscarEMostrarNovasVendas() {
      this.saleNew = false;

      new NewSale()
      .getNewSale()
      .then(async (novasVendas) => {
        if (novasVendas) {
          let sale = Array.isArray(novasVendas.data) ? novasVendas.data : [novasVendas.data];
          this.sl = sale.filter(a => a.TIPO == "VENDA");

          for (let i = 0; i < this.sl.length; i++) {
            this.sl[i].IMAGEMVENDEDOR = await this.buscarImagem(this.sl[i].CODPESSOAVENDEDOR);
            if (localStorage.getItem("idMatricula") != this.sl[i].IDPREMATRICULA) {
              this.abrirModal(this.sl[i]);
            }
            await this.delay(3500);
          }
        }
      })
      .catch((response) => {
        if (response && response.data) {
          this.notify.error = response.data.error;
        }
      });
    },

    async buscarImagem(codpessoa) {
      try {
        const res = await new ImageSale().getImageSale(codpessoa);
        return res.data.IMAGEM;
      } catch (error) {
        if (error.response && error.response.data) {
          this.notify.error = error.response.data.error;
        }
        return null;
      }
    },

    abrirModal(sale) {
      this.infoSale = Array.isArray(sale) ? sale : [sale];

      this.saleNew = true;

      localStorage.setItem("idMatricula", this.infoSale[0].IDPREMATRICULA);

      setTimeout(() => {
        this.saleNew = false;
      }, 3000);

      if (this.saleNew == true) {
        const jsConfetti = new JSConfetti()
        jsConfetti.addConfetti()
        const audio = new Audio(require('@/assets/nova-venda.mp3'));
        audio.play();
      }
    }
  },*/
}
</script>

<style>
</style>
